var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-view',{staticClass:"index-view",attrs:{"type":"home"}})
}
var staticRenderFns = []

export { render, staticRenderFns }